/* eslint-disable max-len */
export const ProfessionalDevelopment = (props: Record<string, any>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        aria-hidden={true}
        role="img"
        {...props}
    >
        <g clipPath="url(#clip0_344_158)">
            <path d="M9.14271 15.3038V2.74281C9.14271 2.74281 10.9136 0.775667 16.8843 0.696318C16.9333 0.6957 16.982 0.704963 17.0273 0.723553C17.0727 0.742144 17.1139 0.769681 17.1483 0.804522C17.2187 0.875224 17.2581 0.970955 17.258 1.0707V12.8829C17.2588 12.9801 17.2215 13.0737 17.154 13.1437C17.0866 13.2137 16.9944 13.2545 16.8973 13.2573C10.9151 13.3381 9.14271 15.3038 9.14271 15.3038Z" fill="#AEE2F7" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.14291 15.3038V2.74281C9.14291 2.74281 7.37198 0.775667 1.4013 0.696318C1.35228 0.6957 1.30364 0.704963 1.25828 0.723553C1.21292 0.742144 1.17177 0.769681 1.13729 0.804522C1.06692 0.875224 1.02749 0.970955 1.02764 1.0707V12.8829C1.02684 12.9801 1.06416 13.0737 1.13158 13.1437C1.19901 13.2137 1.29118 13.2545 1.38832 13.2573C7.37054 13.3381 9.14291 15.3038 9.14291 15.3038Z" fill="#AEE2F7" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.3065 5.40849C12.5341 4.9956 13.809 4.73989 15.1009 4.64746" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.3065 9.43437C12.5341 9.02148 13.809 8.76577 15.1009 8.67334" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.97882 5.40849C5.75125 4.9956 4.47632 4.73989 3.18448 4.64746" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.97882 9.43437C5.75125 9.02148 4.47632 8.76577 3.18448 8.67334" stroke="#1D2D5A" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_344_158">
                <rect width="18" height="16" fill="white" transform="matrix(-1 0 0 1 18 0)" />
            </clipPath>
        </defs>
    </svg>
);
ProfessionalDevelopment.displayName = "ProfessionalDevelopment";
